<template>
  <transition name="fade">
    <v-footer :absolute="true"
              class="bg-transparent"
    >
      <v-col class="pa-1 text-center" cols="6" offset="3">
          <AppButton
            rounded
            text
            size="small"
          >
            <AppDownloadFile :link="urlCGU" forceReader>
              <template #default="{ submitForm }">
                <span @click="submitForm">
                  {{ $t('common.Footer.termsOfUse') }}
                </span>
              </template>
            </AppDownloadFile>
          </AppButton>
          <AppButton rounded
                     text
                     size="small"
                     :href="$t('common.Footer.trustCenterLink')"
          >
            {{$t('common.Footer.trustCenter')}}
          </AppButton>
          <AppButton rounded
                     text
                     size="small"
                     :href="$t('common.Footer.helpUrl')"
          >
            {{$t('common.Footer.help')}}
          </AppButton>
      </v-col>
    </v-footer>
  </transition>
</template>

<script>
import AppDownloadFile from './AppDownloadFile.vue'
import AppButton from './buttons/AppButton.vue'
/**
 * Default App footer
 * @displayName AppFooter
 */
/**
 * Default App footer
 */
export default {
  name: 'AppFooter',
  components: { AppButton, AppDownloadFile },
  computed: {
    urlCGU () {
      return `${import.meta.env.VUE_APP_API_URL}/assets/pdf?file=terms-of-service-${this.$i18n.locale.toUpperCase()}`
    },
    closdVersion () {
      return __APP_VERSION__
    },
  },
}
</script>
